function ellipsify(text: string, len: number = 30) {
    if(!text) return "";
    if(len > text.length) return text;
    return text.slice(0, len) + "…";
}

export default ellipsify;